import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import Wrapper from 'src/components/Wrapper';
import { ITheme } from 'src/Entities/Theme';
import { ToastContainer, addToast, clearToasts } from 'src/components/Toast';
import ThemeSectionForm, {
  IThemeSectionFormValues
} from './components/ThemeSectionForm';
import ThemeSectionList from './components/ThemeSectionList';
import InitialMessage from './components/InitialMessage';
import { getThemes, updateTheme } from 'src/helpers/api';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import { webRefetchActivityThemesaction } from 'src/Entities/ActivityTheme/ActivityTheme.Actions';

interface IThemeSectionEditorParams {
  id?: string;
}

interface IThemeSectionEditorProps extends RouteComponentProps<IThemeSectionEditorParams> {
  refetchThemes: () => void;
}

const ThemeSectionEditor = ({
  match,
  history,
  refetchThemes
}: IThemeSectionEditorProps) => {
  const [themes, setThemes] = React.useState<ITheme[]>([]);

  React.useEffect(() => {
    getThemes().then(fetchedThemes => setThemes(fetchedThemes));
  }, []);

  const activeThemeId: null | number = React.useMemo(
    () => (match.params.id ? parseInt(match.params.id, 10) : null),
    [match.params]
  );
  const activeTheme: null | ITheme = React.useMemo(() => {
    const theme = themes.find(({ themeId }) => themeId === activeThemeId);
    return theme || null;
  }, [activeThemeId, themes]);

  const handleSubmit = async (values: IThemeSectionFormValues) => {
    await Promise.resolve(values);

    if (activeTheme != null) {
      await updateTheme(activeTheme.themeId, values);
      await getThemes().then(fetchedThemes => setThemes(fetchedThemes));
      refetchThemes();
      addToast({ type: 'info', message: 'Temaet blev opdateret' });
    }
    return;
  };

  return (
    <div className="has-background-gray-body pb-14">
      <Wrapper>
        <Breadcrumb className="pt3">
          <BreadcrumbItem>
            <Link to="/">Forside</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active={true}>
            <Link to="">Temasektioner</Link>
          </BreadcrumbItem>
        </Breadcrumb>
        <h1 className="uppercase font-light text-lg my-5">
          Rediger temasektioner
        </h1>
        <div className="flex">
          <div className="has-background-light-3 py-6 pl-6 w-96 flex-none relative PageListContainer">
            <ThemeSectionList activeThemeId={activeThemeId} themes={themes} />
          </div>
          <div className="flex-1 has-background-white relative">
            {!activeTheme && <InitialMessage />}
            {activeTheme && (
              <ThemeSectionForm
                onSubmit={handleSubmit}
                onCancel={() => {
                  history.replace('/cms/temasektioner');
                }}
                theme={activeTheme}
              />
            )}
            <ToastContainer />
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => ({
  refetchThemes: () => dispatch(webRefetchActivityThemesaction())
});

export default connect(null, mapDispatchToProps)(ThemeSectionEditor);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/ThemeSectionEditor/index.tsx